var containerHolder = new Map();
/**
 * 获取 `React.createPortal` 容器元素
 * @param containerId 容器元素 ID
 */
export function getPortalContainer(containerId, _a) {
    if (containerId === void 0) { containerId = 'overlay-root'; }
    var _b = _a === void 0 ? {} : _a, onCreated = _b.onCreated;
    var element = containerHolder.get(containerId);
    if (!element) {
        element = document.getElementById(containerId);
        if (!element) {
            element = document.createElement('div');
            element.id = containerId;
            if (typeof onCreated === 'function') {
                onCreated(element);
            }
            document.body.appendChild(element);
        }
        containerHolder.set(containerId, element);
    }
    return element;
}
